import { playSound } from "../utils/gameAudio";

export const HOL_HOT_SEAT_CLAP_URL =
  "https://cdn.pixabay.com/audio/2022/11/04/audio_7b2d96a98f.mp3";

export const HOL_CARD_FLIP_URL =
  "https://cdn.pixabay.com/audio/2022/03/15/audio_e385f1aa0d.mp3";

/** Play a Higher-or-Lower action from the sound map, with URL fallback. Returns Audio when played directly. */
export function playHolSound(sounds, playFn, actionKey, fallbackUrl, options = {}) {
  const { loop = false, forceDirect = false } = options;
  const cfg = sounds?.[actionKey];
  const url = cfg?.audio_url || fallbackUrl;
  if (!url) return null;

  if (!loop && !forceDirect && cfg?.audio_url && typeof playFn === "function") {
    playFn(actionKey);
    return null;
  }

  return playSound(url, {
    volume: cfg?.volume ?? 1,
    loop: !!loop,
  });
}

export function stopHolAudio(audio) {
  if (!audio) return;
  try {
    audio.pause();
    audio.currentTime = 0;
  } catch {
    /* ignore */
  }
}
